module.exports = __webpack_public_path__ + "img/default_avatar.89c92241.png";